import {
	HttpEvent,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { FirebaseTokenService } from 'app/core/services/firebase-token-service.service';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { isAuthEndpoint } from './interceptor.utils';

export const jwtInterceptorFn: HttpInterceptorFn = (
	req: HttpRequest<any>,
	next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
	if (isAuthEndpoint(req.url)) return next(req);

	const tokenService = inject(FirebaseTokenService);

	return tokenService.getIdToken$().pipe(
		switchMap(token => {
			const authReq = token
				? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
				: req;

			return next(authReq);
		}),
		catchError(() => next(req))
	);
};